import React from 'react';
import { Link } from 'react-router-dom';
import BackButton from '@/components/BackButton';

const Documentation: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Documentation</h1>
          
          <h2>Getting Started</h2>
          <p>
            NEXUS Phish is a powerful platform for security research and phishing awareness training. 
            This documentation will help you understand and utilize all features effectively.
          </p>

          <h2>Platform Features</h2>
          <ul>
            <li>
              <strong>Template Library</strong> - Access to multiple login page templates for various services
            </li>
            <li>
              <strong>Telegram Integration</strong> - Real-time notifications for login attempts
            </li>
            <li>
              <strong>Customization Options</strong> - Modify templates to match specific scenarios
            </li>
            <li>
              <strong>Data Collection</strong> - Secure storage and management of collected information
            </li>
          </ul>

          <h2>Setup Guide</h2>
          <h3>1. Telegram Bot Configuration</h3>
          <ol>
            <li>Message @BotFather on Telegram</li>
            <li>Create a new bot using the /newbot command</li>
            <li>Copy the provided API token</li>
            <li>Configure the token in NEXUS Phish settings</li>
          </ol>

          <h3>2. Template Usage</h3>
          <ol>
            <li>Browse available templates in the gallery</li>
            <li>Select a template for your testing scenario</li>
            <li>Configure notification settings</li>
            <li>Deploy and monitor results</li>
          </ol>

          <h2>Best Practices</h2>
          <ul>
            <li>Always obtain proper authorization before testing</li>
            <li>Use dedicated testing environments</li>
            <li>Regularly review and delete collected data</li>
            <li>Follow security guidelines and compliance requirements</li>
          </ul>

          <h2>API Reference</h2>
          <p>
            For developers looking to extend functionality, our API documentation provides detailed information about available endpoints and integration options.
          </p>

          <div className="not-prose mt-8 border-t pt-8">
            <p className="text-sm text-muted-foreground">
              Need more help? Check our <Link to="/faq" className="text-primary hover:underline">FAQ</Link> or <Link to="/contact" className="text-primary hover:underline">contact support</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentation;